import {
    CompetitorResultsDetail,
    CompetitorRoundResultWarning,
    LeagueCompetitor,
    LeaguePoints
} from "@model";

export class LeagueCompetitorRoundResult {
    // from CompetitorResults — race context
    competitorId?:number;
    raceId?:number;
    eventId?:number;
    competitorResultsDetail?: CompetitorResultsDetail;

    // race ranks
    raceAbsoluteRank?:number;
    raceSexRank?:number;
    raceCategoryRank?:number;
    raceChipAbsoluteRank?:number;
    raceChipSexRank?:number;
    raceChipCategoryRank?:number;
    status?:string;startNumber?:string;

    // from league competitor — league context identity
    leagueCompetitorId?:number;
    leagueCompetitor?: LeagueCompetitor;
    warnings?: CompetitorRoundResultWarning[];
    points?:LeaguePoints;
    countStatus?: RoundCountStatus;
    isInvalidated?:boolean;
}

export enum RoundCountStatus {
    INCLUDED = 1,
    NOT_INCLUDED = 0,
}